export const SET_STATE = 'checkoutPage/customerDetails/SET_STATE';
export const SET_AND_VALIDATE_INPUT_VALUE = 'checkoutPage/customerDetails/SET_AND_VALIDATE_INPUT_VALUE';
export const SET_INPUT_FIELD_VALIDITY = 'checkoutPage/customerDetails/SET_INPUT_FIELD_VALIDITY';
export const RESET_CUSTOMER_DETAILS = 'checkoutPage/customerDetails/RESET_CUSTOMER_DETAILS';
